import React from 'react'
import ExperienceListPresentation from '../../presentation/expereince.list.presentation/ExperienceListPresentation'
import { type EntityId, type EntityState } from '@reduxjs/toolkit'
import { type ExperienceCard } from '../../types/types'
import { useNavigate } from 'react-router-dom'

// ExperienceListContianer props
interface ExperienceListContainerPorps {
  list: EntityState<ExperienceCard>
  onSort: (fieldName: string) => void
  sort: string
  page?: number
  limit?: number
  onPage?: (pageNumber: number) => void
  onLimit?: (limitNumber: number) => void
  onDelete: (id: EntityId) => void
}

// ExperineceListContainer component that is follow the container persentation pattern this is container component for experience list
const ExperiecneListContainer: React.FC<ExperienceListContainerPorps> = ({
  list,
  onSort,
  sort,
  page,
  limit,
  onPage,
  onLimit,
  onDelete
}) => {
  // useNavgation hook for navigatie between page
  const navigation = useNavigate()

  // onEditHandler is a handler for when you hit on edit button on list

  const onEditHanlder = (id: EntityId) => {
    navigation(`/experience/expdetails/${id}`,{state : {isPrerequisites : false}
    
    })
  }


  // onPluseHandler is a handler for when you hit on edit button on list
  const onPlusHanlder = (id: EntityId) => {
    navigation(`/experience/expdetails/${id}`,{state : {isPrerequisites : true}
    
    })
  }

  // onReviewHandler is an event handler for when you hit the button of Review on the exp list
  const onReviewHandler = (id: EntityId) => {
    navigation(`/experience/expReview/${id}`)
  }

  
  return (
    // return the persentation
    <ExperienceListPresentation
      list={list}
      onEdit={onEditHanlder}
      onPlus={onPlusHanlder}
      onReview={onReviewHandler}
      onDelete={onDelete}
      onSort={onSort}
      sort={sort}
      page={page}
      limit={limit}
      onLimit={onLimit}
      onPage={onPage}
     
    />
  )
}

export default ExperiecneListContainer
